import _ = require('underscore');

import { EntityActionNames, IEntityAction } from '~src/spacesPlatform/components/ActionsMenu/EntityActions/IEntityAction';

import { Messages } from '../../codegen/Localize';
import { deleteSubscriptions } from '../actions/SubscriptionsActions';
import { ISubscriptionInfo } from '../models/ISubscriptionInfo';

export const UnsubsribeFromSubscriptionsEntityAction: IEntityAction<ISubscriptionInfo, {}> = {
  name: EntityActionNames.UnsubscribeSubscriptions,
  translateName: Messages.unsubscribe_action,
  isVisible: () => true,
  isClickable: (availableActions: {}, subscriptions: ISubscriptionInfo[]) => {
    return _.any(subscriptions, (subscription) => subscription.canManageSubscription);
  },
  createReduxAction: (subscriptions: ISubscriptionInfo[]) => deleteSubscriptions(subscriptions)
};
